/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {diplomatObjectSchema} from './diplomat-object';
import {IPAccessRulesSettings} from './diplomat/sftp/IPAccessRulesSettings';
export const AuthenticationPolicies = diplomatObjectSchema.shape({
   caseInsensitiveAuthentication: yup.boolean(),
   accessRule: IPAccessRulesSettings,
   ssoOnly: yup.boolean().default(false),
});

export type IAuthenticationPolicies = yup.InferType<typeof AuthenticationPolicies>;
